<template>
  <BLayoutList
    :title="pageTitle"
    :skeleton="isLoadingAsyncData"
  >
    <BTableCommon
      v-model="selected"
      type="passport-templates"
      :list="list"
      :pagination="pagination"
      :ordering="filters.ordering"
      :loading="isLoading"
      :skeleton="isLoadingAsyncData"
      @change:pagination="onChangePagination"
      @change:sort="onChangeSort"
      @action:delete="onDeleteWithRefresh"
      @action:edit="onActionEdit"
      @action:view="onActionView"
    />
  </BLayoutList>
</template>

<script>
import { createListMixin } from '@/helpers/mixins/createListMixin'
import { PassportPageModel as Model } from './Model'
import { PassportTemplatesStoreModule as StoreModule } from './store'

import BLayoutList from '@/components/layouts/BLayoutList.vue'
import BTableCommon from '@/components/tables/BTableCommon.vue'
import { PASSPORT_PAGES_ROUTES as ROUTES } from './utils'


const mixinOptions = { Model, StoreModule }
const listMixin = createListMixin(mixinOptions)


/** @typedef { import('@/helpers/mixins/createListMixin').ListMixin<any, StoreModule> } List */

export default {
  name: 'PassportTemplatesList',
  components: {
    BLayoutList,
    BTableCommon,
  },
  mixins: [
    listMixin,
  ],
  methods: {
    onActionEdit(data) {
      this.$router.push({
        name: ROUTES.EDIT,
        params: {
          id: data.id,
        },
      })
    },
    onActionView(data) {
      this.$router.push({
        name: ROUTES.VIEW,
        params: {
          id: data.id,
        },
      })
    },
  },
}
</script>
